import { render, staticRenderFns } from "./CardSubcategory.vue?vue&type=template&id=129c6e26&scoped=true&"
import script from "./CardSubcategory.vue?vue&type=script&lang=js&"
export * from "./CardSubcategory.vue?vue&type=script&lang=js&"
import style0 from "./CardSubcategory.vue?vue&type=style&index=0&id=129c6e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129c6e26",
  null
  
)

/* custom blocks */
import block0 from "./CardSubcategory.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports